import React from "react";
import styles from "./MasterData.module.scss";

export default function MasterDetailBlock({
  title,
  label,
  value,
}: {
  title: string;
  label: string;
  value?: React.ReactNode;
}) {
  if (!value) return null;
  return (
    <>
      <h5 className="mt-4 fw-bold">{title}</h5>
      <div className={styles.detailCard}>
        <span className="fw-bold">{label}:</span> {value}
      </div>
    </>
  );
}
